import cn from 'classnames';
import React, { ComponentPropsWithoutRef, FC } from 'react';
import LogoSVG from 'src/shared/assets/svg/denominator_logo.svg';
import LogoNoLineSVG from 'src/shared/assets/svg/denominator_logo_no_line.svg';
import s from './Logo.module.scss';

interface Props extends ComponentPropsWithoutRef<'a'> {
	line?: boolean;
}

export const Logo: FC<Props> = (props) => {
	const {
		line = true, //
		className,
		...restProps
	} = props;

	// * Render
	return (
		<a
			className={className}
			{...restProps}
		>
			{line ? <LogoSVG className={cn(s.container)} /> : <LogoNoLineSVG className={cn(s.container)} />}
		</a>
	);
};
